import EntityDetailContainer from "./EntityDetailContainer";
export default EntityDetailContainer;
